module.exports = __webpack_public_path__ + "static/media/tr.28b8c158.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tr.svg
// module id = 1178
// module chunks = 0